import { activityDetailStore } from '@client/store/activityDetailStore';
import { computed } from 'vue';
import { i18n } from '@client/helper/i18n';
import Definition from '@client/config/definition';
import { useActivityDetail } from '../../hooks/useActivityDetail';

const { t } = i18n;

export function useModels() {
  const activityDetailStoreRef = activityDetailStore();
  const { curActivityDetail } = useActivityDetail();
  const sportType = computed(() => curActivityDetail.value?.summary.sportType);

  // 图表模式选项
  const models = computed(() => {
    let result = [];
    if (activityDetailStoreRef.activityDetail?.sportDataDetailList?.length > 0) {
    } else {
      result = [
        // 时间
        {
          key: 'time',
          text: t('H6016')
        }
      ];
      const sportName = Definition.getSportNameByType(sportType.value);

      if (['Strength', 'Gym_Cardio'].includes(sportName)) {
        result.push({
          key: 'distance',
          text: {
            // 动作
            Strength: t('H6010'),
            // 计圈
            Gym_Cardio: t('H6001')
          }[sportName]
        });
      } else if (![undefined, null, '', 0].includes(activityDetailStoreRef.activityDetail?.summary.distance)) {
        result.push({
          key: 'distance',
          text: t('H1040')
        });
      }
    }
    if (result.length === 1) {
      result = [];
    }
    return result;
  });

  return {
    models
  };
}
